module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/monitoringZivotnihoProstredi-14f6d8bab9a3e5c2a01a3d1577b87a30.png";